import React, { useState } from 'react'

import { Box, Stack } from '@mui/material'
import { DatePicker } from '@mui/x-date-pickers'
import { LoadingButton } from '@mui/lab'
import { BackupTable, PictureAsPdf } from '@mui/icons-material'
import { useQuery } from 'react-query'
import { AxiosResponse } from 'axios'
import { format } from 'date-fns'
import { downloadXLSXFile, openPDFFile } from '../../../Functions/DownloadFile'
import PageSection from '../../../Constants&Theme/PageSection'
import ReportService from '../../../APIs/PHP/APIs/ReportService'
import { useUserContext } from '../../../Contexts/UserConfig'
import { useMessagePopupContext } from '../../../garvan-react/Components/ModalFeedback/MessagePopup'

function ShippingManifestReport() {
  const { whoAmI } = useUserContext()
  const { setError } = useMessagePopupContext()

  const [vanRunDate, setVanRunDate] = useState<Date | null>(null)
  const [loadPdf, setLoadPdf] = useState(false)
  const [loadXlsx, setLoadXlsx] = useState(false)

  const {
    data: pdfData,
    isLoading: pdfLoading,
    error: pdfError,
  } = useQuery<any, AxiosResponse>(
    ['ReportService', 'getShippingManifestPDF', vanRunDate],
    () =>
      ReportService.getShippingManifestPDF(
        whoAmI,
        format(vanRunDate!, 'yyyy-MM-dd'),
      ),
    {
      enabled: !!vanRunDate && loadPdf,
      onSuccess: (data) => {
        openPDFFile(data, format(vanRunDate!, 'yyyy-MM-dd'))
        setLoadPdf(false)
      },
      onError: (err) => setError(err),
    },
  )

  const {
    data: xlsxData,
    isLoading: xlsxLoading,
    error: xlsxError,
  } = useQuery<any, AxiosResponse>(
    ['ReportService', 'getShippingManifestXLSX', vanRunDate],
    () =>
      ReportService.getShippingManifestXLSX(
        whoAmI,
        format(vanRunDate!, 'yyyy-MM-dd'),
      ),
    {
      enabled: !!vanRunDate && loadXlsx,
      onSuccess: (data) => {
        downloadXLSXFile(data, format(vanRunDate!, 'yyyy-MM-dd'))
        setLoadXlsx(false)
      },
      onError: (err) => setError(err),
    },
  )

  return (
    <Box
      sx={{
        maxWidth: 'xl',
        width: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <PageSection title={'Shipping Manifest Report'}>
        <DatePicker
          label="Van Run Date"
          value={vanRunDate}
          onOpen={() => {
            setLoadXlsx(false)
            setLoadPdf(false)
          }}
          onChange={(newValue) => setVanRunDate(newValue)}
        />
        <Stack
          spacing={1}
          direction={'row'}
          sx={{ mt: 1 }}
        >
          <LoadingButton
            size={'large'}
            variant={'outlined'}
            startIcon={<BackupTable />}
            loading={xlsxLoading}
            disabled={!vanRunDate}
            onClick={() => {
              if (xlsxData) {
                downloadXLSXFile(xlsxData, format(vanRunDate!, 'yyyy-MM-dd'))
              } else if (xlsxError) {
                setError(xlsxError)
              } else {
                setLoadXlsx(true)
              }
            }}
          >
            Download .xlsx
          </LoadingButton>
          <LoadingButton
            size={'large'}
            variant={'outlined'}
            startIcon={<PictureAsPdf />}
            loading={pdfLoading}
            disabled={!vanRunDate}
            onClick={() => {
              if (pdfData) {
                openPDFFile(pdfData, format(vanRunDate!, 'yyyy-MM-dd'))
              } else if (pdfError) {
                setError(pdfError)
              } else {
                setLoadPdf(true)
              }
            }}
          >
            Open .pdf
          </LoadingButton>
        </Stack>
      </PageSection>
    </Box>
  )
}

export default ShippingManifestReport
